<template>
  <div id="RememberPassword" class="remember-password-page" dir="rtl">
    <div class="remember-password-glow remember-password-glow--primary" aria-hidden="true"></div>
    <div class="remember-password-glow remember-password-glow--secondary" aria-hidden="true"></div>
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      :title="pageTitle"
      :description="pageDescription"
      :show-back="true"
      wrap-class="remember-password-card-wrap netpa-list-page-card-wrap--inset netpa-list-page-card-wrap--centered no-print"
    >
      <div class="remember-password-content">
        <div class="remember-password-panel">
          <div class="remember-password-brand-mark" aria-hidden="true">
            <i class="fas fa-unlock-alt"></i>
          </div>
          <form v-if="stage == 1" id="div1" class="remember-password-form">
          <div class="remember-password-field">
            <label class="remember-password-label" for="remember-codemeli">کد ملی</label>
            <input
              id="remember-codemeli"
              class="form-control text-center required remember-password-input"
              dir="ltr"
              type="number"
              v-model="Codemeli"
              placeholder="کد ملی"
              autocomplete="username"
              inputmode="numeric"
              @keypress="$BlockSuspiciousInput($event, 11)"
              @keyup="$BlockSuspiciousInput($event, 12)"
            />
          </div>
          <div class="remember-password-field">
            <label class="remember-password-label" for="remember-mobile">شماره موبایل</label>
            <input
              id="remember-mobile"
              class="form-control text-center required remember-password-input"
              dir="ltr"
              type="number"
              v-model="mobile"
              placeholder="شماره موبایل"
              autocomplete="tel"
              inputmode="numeric"
              @keypress="$BlockSuspiciousInput($event, 11)"
              @keyup="$BlockSuspiciousInput($event, 12)"
            />
          </div>
          <div class="remember-password-field remember-password-field--captcha">
            <span class="remember-password-label">کد امنیتی</span>
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div class="remember-password-actions">
            <button
              type="button"
              :disabled="!CaptchaValid"
              class="btn remember-password-submit-btn"
              @click.prevent="sendSms"
            >
              ارسال پیامک بازیابی
            </button>
          </div>
        </form>

        <form v-else id="divpass" class="remember-password-form">
          <div class="remember-password-field">
            <label class="remember-password-label" for="remember-otp">کد یکبار مصرف</label>
            <input
              id="remember-otp"
              type="number"
              placeholder="کد یکبار مصرف"
              class="form-control text-center required remember-password-input"
              dir="ltr"
              v-model="yekbarRamz"
              autocomplete="one-time-code"
              inputmode="numeric"
            />
          </div>
          <div class="remember-password-field remember-password-field--password">
            <label class="remember-password-label" for="remember-new-pass">رمز عبور جدید</label>
            <input
              id="remember-new-pass"
              :type="showPass ? 'text' : 'password'"
              placeholder="رمز عبور جدید"
              class="form-control text-center required required-Pass remember-password-input"
              dir="ltr"
              v-model="newPass"
              @keypress="$BlockSuspiciousInput($event, 30)"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="remember-password-toggle-eye"
              @click="showPass = !showPass"
              aria-label="نمایش یا پنهان‌کردن رمز عبور جدید"
            >
              <i v-if="showPass" class="fa fa-eye-slash" aria-hidden="true"></i>
              <i v-else class="fa fa-eye" aria-hidden="true"></i>
            </button>
          </div>
          <div class="remember-password-field remember-password-field--password">
            <label class="remember-password-label" for="remember-repeat-pass">تکرار رمز عبور</label>
            <input
              id="remember-repeat-pass"
              :type="showPass2 ? 'text' : 'password'"
              placeholder="تکرار رمز عبور"
              class="form-control text-center required required-Pass remember-password-input"
              dir="ltr"
              v-model="NewPassRepeat"
              @keypress="$BlockSuspiciousInput($event, 30)"
              @keyup="$BlockSuspiciousInput($event, 30)"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="remember-password-toggle-eye"
              @click="showPass2 = !showPass2"
              aria-label="نمایش یا پنهان‌کردن تکرار رمز عبور"
            >
              <i v-if="showPass2" class="fa fa-eye-slash" aria-hidden="true"></i>
              <i v-else class="fa fa-eye" aria-hidden="true"></i>
            </button>
          </div>
          <div class="remember-password-field remember-password-field--captcha">
            <span class="remember-password-label">کد امنیتی</span>
            <CaptchaBox ref="captchaRef" @update="onCaptchaValid"></CaptchaBox>
          </div>
          <div class="remember-password-actions">
            <button
              type="button"
              :disabled="!CaptchaValid"
              class="btn remember-password-submit-btn"
              @click.prevent="changepass"
            >
              تغییر رمز
            </button>
          </div>
        </form>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>

<script>
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import loading from "../Tools/NetPa/Loading.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  components: { NetPaListPageCard, loading, CaptchaBox },
  data() {
    return {
      showPass: false,
      showPass2: false,
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      mobile: "",
      Codemeli: "",
      stage: 1,
      validation: false,
      NewPassRepeat: "",
      newPass: "",
      yekbarRamz: "",
      loadingRender: false,
    };
  },
  computed: {
    pageTitle() {
      return this.stage === 1 ? "بازیابی رمز عبور" : "تغییر رمز عبور";
    },
    pageDescription() {
      if (this.stage === 1) {
        return "برای دریافت پیامک بازیابی، کد ملی و شماره موبایل ثبت‌شده در سیستم را وارد کنید";
      }
      return "کد پیامک‌شده و رمز عبور جدید خود را وارد کنید";
    },
  },
  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.Codemeli == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.mobile.length != 11) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه 11 رقمی است.",
            "error",
            2000,
          );
          return;
        } else {
          this.loadingRender = true;
          var DataAxiosForget = {
            ArryfildValue: {},
            Action: "Bazyabi/RememberPass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append("mobile", this.mobile);
          formData.append("codeMeli", this.Codemeli);
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosForget.ArryfildValue = formData;
          this.$PostFormData(DataAxiosForget).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 3000);
            if (data.status == "Ok") {
              this.stage = 2;
              this.loadingRender = false;
              this.CaptchaValid = false;
              this.$nextTick(() => this.refreshCaptcha());
            } else {
              this.refreshCaptcha();
              this.stage = 1;
              this.loadingRender = false;
            }
          });
        }
      }
    },
    changepass() {
      if (this.$ValidForm("divpass")) {
        this.loadingRender = true;
        if (this.newPass == this.NewPassRepeat) {
          var DataAxiosChangePass = {
            ArryfildValue: {},
            Action: "Bazyabi/UpdatePass",
            Method: "POST",
            Token: "",
          };
          const formData = new FormData();
          formData.append(
            "AxarinTaghirPass",
            this.$store.state.JalaliDateAndTime,
          );
          formData.append("newPass", this.newPass);
          formData.append("randomKey", this.yekbarRamz);
          formData.append("codeMeli", this.Codemeli);
          formData.append("CustomerCode", this.$session.get("CustCode"));
          formData.append("userInput", this.captchaText);
          formData.append("captchaId", this.captchaId);
          DataAxiosChangePass.ArryfildValue = formData;
          this.$PostFormData(DataAxiosChangePass).then((data) => {
            this.$mySweetDefaultTost(" ", data.msg, data.icone, 2000);
            if (data.status == "Ok") {
              this.$router.go(-1);
            } else {
              this.refreshCaptcha();
              this.loadingRender = false;
              this.stage = 2;
            }
          });
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            " خطا",
            "رمز عبور وارد شده و تکرارش برابر نیستند!",
            "error",
            2000,
          );
          return;
        }
      }
    },
    checkregex(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z0-9]+$/.test(char)) {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف انگلیسی و اعداد  مجاز هستند",
          "error",
          2000,
        );
        e.preventDefault();
      }
    },
  },
  mounted() {
    this.NewPassRepeat = "";
    this.newPass = "";
    this.yekbarRamz = "";
  },
};
</script>

<style scoped>
.remember-password-page {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #f3eef8;
  --bnp-border-default: #dbe5eb;
  --bnp-border-hover: #bdcbd4;
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;

  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  padding: 12px 0 28px;
  color: var(--bnp-text-primary);
  background:
    radial-gradient(circle at 12% 12%, rgba(141, 88, 164, 0.14), transparent 28%),
    radial-gradient(circle at 88% 88%, rgba(5, 184, 200, 0.1), transparent 30%),
    linear-gradient(145deg, #f8fbfc 0%, #f3eef8 48%, #f8fafc 100%);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.remember-password-page::before {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  content: "";
  opacity: 0.38;
  background-image:
    linear-gradient(rgba(15, 39, 68, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 39, 68, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(to bottom, black, transparent 80%);
}

.remember-password-glow {
  position: fixed;
  z-index: 0;
  width: 360px;
  height: 360px;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(2px);
}

.remember-password-glow--primary {
  top: -190px;
  right: -130px;
  background: rgba(141, 88, 164, 0.14);
}

.remember-password-glow--secondary {
  bottom: -220px;
  left: -120px;
  background: rgba(5, 184, 200, 0.1);
}

.remember-password-content {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 8px 4px 4px;
}

.remember-password-panel {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  text-align: right;
}

.remember-password-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 18px;
  color: #fff;
  font-size: 20px;
  border-radius: 15px;
  background: linear-gradient(
    145deg,
    var(--bnp-brand-cyan),
    var(--bnp-brand-purple)
  );
  box-shadow: 0 10px 26px rgba(107, 91, 169, 0.28);
}

.remember-password-form {
  width: 100%;
  direction: rtl;
}

.remember-password-field {
  margin-bottom: 16px;
  text-align: right;
}

.remember-password-label {
  display: block;
  margin-bottom: 8px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.remember-password-input {
  width: 100%;
  height: 52px;
  padding: 0 16px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 14px;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  outline: none;
  background: var(--bnp-surface-subtle);
  box-shadow: none;
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.remember-password-input::placeholder {
  color: #99a6b4;
}

.remember-password-input:hover {
  border-color: var(--bnp-border-hover);
}

.remember-password-input:focus {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.remember-password-input[type="number"] {
  -moz-appearance: textfield;
}

.remember-password-input[type="number"]::-webkit-inner-spin-button,
.remember-password-input[type="number"]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.remember-password-field--password {
  position: relative;
}

.remember-password-field--password .remember-password-input {
  padding-left: 48px;
}

.remember-password-toggle-eye {
  position: absolute;
  left: 8px;
  bottom: 4px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  color: #718296;
  font-size: 16px;
  border: 0;
  border-radius: 10px;
  outline: none;
  background: transparent;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.remember-password-toggle-eye:hover {
  color: var(--bnp-brand-indigo);
  background: var(--bnp-surface-accent);
}

.remember-password-toggle-eye:focus-visible {
  color: var(--bnp-brand-indigo);
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.remember-password-actions {
  margin-top: 8px;
}

.remember-password-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 52px;
  padding: 10px 22px;
  color: #fff !important;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    opacity var(--bnp-motion-fast) ease;
}

.remember-password-submit-btn:not(:disabled):hover {
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 16px 30px rgba(15, 39, 68, 0.24);
}

.remember-password-submit-btn:focus-visible {
  box-shadow:
    var(--bnp-focus-ring),
    var(--bnp-shadow-md);
}

.remember-password-submit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.68;
}

.remember-password-field--captcha ::v-deep .input-group {
  margin-bottom: 0 !important;
}

.remember-password-field--captcha ::v-deep .form-control {
  height: 52px;
  min-height: 52px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 14px;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md) 0 0 var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
  box-shadow: none;
}

.remember-password-field--captcha ::v-deep .form-control:focus {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.remember-password-field--captcha ::v-deep .input-group-text {
  height: 52px;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid var(--bnp-border-default);
  border-right: 0;
  border-radius: 0 var(--bnp-radius-md) var(--bnp-radius-md) 0;
  background: #fff;
}

.remember-password-field--captcha ::v-deep .input-group-text img {
  height: 52px;
  width: auto;
}

@media (max-width: 479.98px) {
  .remember-password-page {
    padding-bottom: 12px;
  }

  .remember-password-input,
  .remember-password-submit-btn {
    min-height: 50px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .remember-password-page *,
  .remember-password-page *::before,
  .remember-password-page *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}
</style>

<style>
#RememberPassword .remember-password-card-wrap {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  #RememberPassword
    .remember-password-card-wrap.netpa-list-page-card-wrap--centered {
    max-width: 560px;
  }
}

#RememberPassword .netpa-list-page-card {
  overflow: hidden;
  border: 1px solid rgba(15, 39, 68, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow:
    0 18px 48px rgba(15, 39, 68, 0.1),
    0 6px 18px rgba(15, 39, 68, 0.05);
  backdrop-filter: blur(10px);
}

#RememberPassword .netpa-list-page-card__intro {
  padding: 1rem 1.15rem;
  background: linear-gradient(
    110deg,
    #29345f,
    #56508d 58%,
    #8d58a4
  ) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

#RememberPassword .netpa-list-page-card__title {
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 800;
}

#RememberPassword .netpa-list-page-card__desc {
  color: rgba(232, 242, 248, 0.86) !important;
  font-size: 13px;
  line-height: 1.7;
}

#RememberPassword .netpa-list-page-card__back-btn {
  width: 44px;
  height: 44px;
  border-radius: 10px;
}

#RememberPassword .netpa-list-page-card__back-btn i {
  color: #fff !important;
}

#RememberPassword .netpa-list-page-card__back-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

#RememberPassword .netpa-list-page-card__back-btn:focus-visible {
  outline: 2px solid rgba(5, 184, 200, 0.7);
  outline-offset: 2px;
}

#RememberPassword .netpa-list-page-card__body {
  padding: 1.25rem 1.15rem 1.35rem;
}

#RememberPassword input.inputValidetaEh {
  display: block !important;
  width: 100% !important;
  height: 52px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #13243a !important;
  background-color: #f9fbfc !important;
  background-clip: padding-box !important;
  border: 1px solid #dbe5eb !important;
  border-radius: 14px !important;
  transition:
    border-color 180ms ease,
    box-shadow 180ms ease !important;
}

.LeftsideValideta {
  float: none !important;
}

@media (max-width: 767.98px) {
  #RememberPassword .netpa-list-page-card {
    border-radius: 18px;
  }
}
</style>
